import React, { Component } from "react";
import Container from "../../../../modules/commons/Container";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import FakturJualDGI from "./DGI/fakturJualDGI";
import FakturJualNOS from "./NOS/fakturJualNOS";

class FakturJual extends Component {
    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        <Tab id="button_navigate_dgi">DGI</Tab>
                        <Tab id="button_navigate_nos">NOS</Tab>
                    </TabList>
                    <TabPanel>
                        <FakturJualDGI {...this.props} />
                    </TabPanel>
                    <TabPanel>
                        <FakturJualNOS {...this.props} />
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }
}

export default FakturJual;